export enum GetterNames {
  IS_LOGGED_IN = 'IS_LOGGED_IN',
  BALANCE = 'BALANCE',
  PRIMARY_LICENSE = 'PRIMARY_LICENSE',
  FULL_NAME = 'FULL_NAME',
  EMAIL = 'EMAIL',
  LICENSES = 'LICENSES',
  ORDER_HISTORY = 'ORDER_HISTORY',
  ARTICLES = 'ARTICLES',
  RELATION_ID = 'RELATION_ID',
  CARD_NUMBER = 'CARD_NUMBER',
  ROLE = 'ROLE',
  IS_COMPANY = 'IS_COMPANY',
  INVOICES = 'INVOICES',
  ADDRESS = 'ADDRESS',
  BUSINESS_NAME = 'BUSINESS_NAME',
  VAT_NUMBER = 'VAT_NUMBER',
}
